export const defaultTermsAndConditions = state => {
    let setting = _.find(state.settings.items, {key: 'terms_and_conditions'})
    return setting ? setting.value : ''
}

export const defaultTermsAndConditionsCH = state => {
    let setting = _.find(state.settings.items, {key: 'terms_and_conditions_ch'})
    return setting ? setting.value : ''
}

export const defaultServiceBilledNotifees = state => {
    let setting = _.find(state.settings.items, {key: 'service_billed_notifees'})
    return setting ? setting.value : []
}